import React from "react";
import { useState, useEffect, useRef } from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import { NavLink } from "react-router-dom";
import { FaCalendarAlt, FaNewspaper } from "react-icons/fa";
import news_item_image from "../resources/images/news-item-image.png";
import top_story_img from "../resources/images/images1.jpeg";
import { FaBullhorn } from "react-icons/fa";
import alumni_img from "../resources/images/user.jpg";
import QuickContact from "../resuables/quick-contact";
import form_three_image from "../resources/images/grouppicform3.jpg";
function Home() {
  const [currentCaroSlide, setCurrentCaroSlide] = useState(1);
  const intervalId = useRef(null);
  const [toggleNewsEvents, setToggleNewsEvents] = useState(true);

  const [screenMode, setScreenMode] = useState(
    window.innerWidth <= 650 ? "small" : "large"
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // fetchMessages()
    const updateScreenMode = () => {
      if (window.innerWidth <= 650) {
        setScreenMode("small");
      } else {
        setScreenMode("large");
      }
    };
    updateScreenMode();
    window.addEventListener("resize", updateScreenMode);
    return () => {
      window.removeEventListener("resize", updateScreenMode);
    };
  }, []);

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalId.current);
  }, []);

  const startAutoSlide = () => {
    intervalId.current = setInterval(() => {
      setCurrentCaroSlide((prevSlide) => (prevSlide < 3 ? prevSlide + 1 : 1));
    }, 8000);
  };

  const handleNext = () => {
    clearInterval(intervalId.current);
    setCurrentCaroSlide((prevIndex) => (prevIndex % 3) + 1);
    startAutoSlide();
  };

  const handlePrev = () => {
    clearInterval(intervalId.current);
    setCurrentCaroSlide((prevIndex) => (prevIndex === 1 ? 3 : prevIndex - 1));
    startAutoSlide();
  };

  return (
    <div className="main">
      {/* <QuickContact/> */}
      <Navbar />
      <div className="content">
        {/* <h2 className = 'content-name'>Home</h2> */}

        <div className="carousel">
          <div className="caro-buttons">
            <span className="left" onClick={handlePrev}>
              {" "}
              &#10094;{" "}
            </span>
            <span className="right" onClick={handleNext}>
              {" "}
              &#10095;{" "}
            </span>
          </div>
          <div className="caro-status">
            <div
              className="circle"
              style={
                currentCaroSlide === 1
                  ? { backgroundColor: "#031c3b", borderColor: "#f47c2c" }
                  : {}
              }
            ></div>
            <div
              className="circle"
              style={
                currentCaroSlide === 2
                  ? { backgroundColor: "#031c3b", borderColor: "#f47c2c" }
                  : {}
              }
            ></div>
            <div
              className="circle"
              style={
                currentCaroSlide === 3
                  ? { backgroundColor: "#031c3b", borderColor: "#f47c2c" }
                  : {}
              }
            ></div>
          </div>

          <div
            className="caro-slides-container"
            style={
              currentCaroSlide === 1
                ? { left: "0%" }
                : currentCaroSlide === 2
                ? { left: "-100%" }
                : currentCaroSlide === 3
                ? { left: "-200%" }
                : {}
            }
          >
            <div className="caro-item" id="caro-item-1">
              <div id="caro-img-1" className="caro-img"></div>

              <div className="legend">
                <div className="leg-content">
                  <h3>WELCOME</h3>
                  <p className="">
                    We are delighted to have you join our community, where
                    academic excellence, character development, and personal
                    growth are at the heart of everything we do. Together, let’s
                    embark on a journey of learning, discovery, and success.
                    Welcome to your new home for education and opportunity!
                  </p>
                  <NavLink to="/admissions">
                    <button>Join Us</button>
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="caro-item" id="caro-item-2">
              <div id="caro-img-2" className="caro-img"></div>
              <div className="legend">
                <div className="leg-content">
                  <h3>
                    {new Date().getFullYear()} / {new Date().getFullYear() + 1}{" "}
                    ADMISSIONS
                  </h3>
                  <p className="">
                    We are pleased to inform prospective applicants and the
                    general public that admission to Star of the East School
                    Complex for the 2024/2025 Academic Year is now open. We
                    warmly invite parents and guardians to enroll their wards in
                    our Junior High School
                  </p>
                  <button>Enroll</button>
                </div>
              </div>
            </div>

            <div className="caro-item" id="caro-item-3">
              <div id="caro-img-3" className="caro-img"></div>
              <div className="legend">
                <div className="leg-content">
                  <h3>
                    {new Date().getFullYear()} / {new Date().getFullYear() + 1}{" "}
                    ADMISSIONS
                  </h3>
                  <p className="">
                    We are pleased to inform prospective applicants and the
                    general public that admission to Star of the East School
                    Complex for the 2024/2025 Academic Year is now open. We
                    warmly invite parents and guardians to enroll their wards in
                    our Junior High School
                  </p>
                  <button>Join Us</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* this section is for news and events  */}
        <h2 className="content-name info-section-header">News & Events</h2>

        <div className="info-section">
          <div className="news-events">
            <div className="news-events-header">
              <span
                onClick={() => {
                  setToggleNewsEvents(true);
                }}
                style={
                  toggleNewsEvents ? { color: "#f47c2c" } : { color: "white" }
                }
              >
                News
              </span>
              {/* <span
                onClick={() => {
                  setToggleNewsEvents(false);
                }}
                style={
                  !toggleNewsEvents ? { color: "#f47c2c" } : { color: "white" }
                }
              >
                Events
              </span> */}
            </div>
            {/* <hr className='news-events-hr'/> */}
            <div className="news-event-container">
              <div
                className="news"
                style={
                  toggleNewsEvents ? { display: "flex" } : { display: "none" }
                }
              >
                <div className="news-item">
                  <div className="news-item-image">
                    <img src={form_three_image} alt="news image" />
                  </div>
                  <div className="news-item-content">
                    <div className="news-item-header">
                      <strong>Science Field Trip to Accra Senior High.</strong>
                    </div>
                    <div className="news-item-summary">
                      <p>
                        On 14th Of May, 2025, students from Light of the World
                        School Complex embarked on an exciting educational trip
                        to Accra Senior High School to participate in a Science
                        Lab Fair and Experimental Workshop. The event provided a
                        hands-on experience for students to explore advanced
                        scientific concepts through practical experiments in
                        physics, chemistry, and biology. Guided by senior high
                        school science tutors and lab assistants, our students
                        had the opportunity to observe real laboratory setups,
                        conduct simple experiments, and deepen their
                        understanding of scientific principles. This enriching
                        experience not only sparked curiosity but also inspired
                        many of our students to pursue science with renewed
                        passion and confidence.
                      </p>
                      <div className="news-details">
                        <FaCalendarAlt />: 14th May, 2025
                      </div>
                    </div>
                  </div>
                </div>

                <div className="news-item">
                  <div className="news-item-image">
                    <img src={form_three_image} alt="news image" />
                  </div>
                  <div className="news-item-content">
                    <div className="news-item-header">
                      <strong>
                        Final Pens Down for BECE Candidates - 2025 YEAR GROUP
                      </strong>
                    </div>
                    <div className="news-item-summary">
                      <p>
                        On 14th of May, 2025, the Form Three students of Light
                        of the World School Complex successfully completed their
                        Basic Education Certificate Examination (BECE) with
                        great determination and confidence. After months of
                        intensive preparation, revision sessions, and guidance
                        from dedicated teachers, the students sat for their
                        final papers with a sense of pride and readiness. The
                        school management and staff were present throughout the
                        week to provide moral support and encouragement. “We are
                        extremely proud of our candidates. They have shown
                        resilience, hard work, and discipline throughout this
                        academic journey,” said Omane, Head of School. The
                        entire Light of the World community joins in celebrating
                        this milestone and looks forward to excellent results
                        and bright futures for all candidates.
                      </p>
                      <div className="news-details">
                        <FaCalendarAlt />: 14th May, 2024
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="news-item">
                  <div className="news-item-image">
                    <img src={news_item_image} alt="news image" />
                  </div>
                  <div className="news-item-content">
                    <div className="news-item-header">
                      <strong>Lorem ipsum dolor sit amet.</strong>
                    </div>
                    <div className="news-item-summary">
                      <p>
                        Lorem ipsum dolor, sit amet consectetur adipisicing
                        elit. Repellat doloremque fugit nobis eius, dicta dolore
                        itaque earum voluptatum esse eaque!
                      </p>
                      <div className="news-details">
                        <FaCalendarAlt />: 8th September, 2024
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              <div
                className="events"
                style={
                  !toggleNewsEvents
                    ? { maxWidth: "0%", overflow: "hidden" }
                    : { maxWidth: "100%" }
                }
              >
                <p>No events yet</p>
                <hr />
              </div>
            </div>
          </div>
          <div className="announcements">
            <span className="announcements-header">
              <FaBullhorn /> Announcements
            </span>
            <hr />
            <p>
              <strong>📢 Admissions Now Open!</strong> <br /> Star of The East
              School Complex is pleased to announce that admissions for the new
              academic year are now open! We welcome applications for all
              classes, from Kindergarten to Junior High School. Join a
              Christ-centered learning environment committed to academic
              excellence, discipline, and holistic development.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <h2 className="content-name info-section-header">Alumni Connect</h2>

        <div className="alumni-section">
          <div className="alumni-content">
            <div className="alumni-item">
              <img src={alumni_img} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> John Asimasi <br />
                <strong>Year Group : </strong>: 2001/2002 <br />
                {/* <strong>Honors : </strong> CEO, Adan Group of Companies */}
              </div>
            </div>

            <div className="alumni-item">
              <img src={alumni_img} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> John Asimasi <br />
                <strong>Year Group : </strong>: 2001/2002 <br />
                {/* <strong>Honors : </strong> CEO, Adan Group of Companies */}
              </div>
            </div>
            <div className="alumni-item">
              <img src={alumni_img} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> John Asimasi <br />
                <strong>Year Group : </strong>: 2001/2002 <br />
                {/* <strong>Honors : </strong> CEO, Adan Group of Companies */}
              </div>
            </div>
            <div className="alumni-item">
              <img src={alumni_img} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> John Asimasi <br />
                <strong>Year Group : </strong>: 2001/2002 <br />
                {/* <strong>Honors : </strong> CEO, Adan Group of Companies */}
              </div>
            </div>
          </div>
        </div>
        {/* <p className='construction-note'>Still Under Construction</p> */}
      </div>
      <Footer />
    </div>
  );
}

export default Home;
